import { queryOptions } from '@tanstack/react-query'
import { queryKeys } from '@core/Data/ReactQuery/constants'
import {
  getFollowMeUserProfileById,
  getPrincipleFollowMeUserProfile,
  getPrincipleFollowMeUserProfileStats,
} from './api'
import { isBetLoopProblemResponse } from './api/typeGuards'

export const followMePrincipleProfileQuery = queryOptions({
  queryKey: queryKeys.followMeAccountProfileBase,
  queryFn: getPrincipleFollowMeUserProfile,
  staleTime: 10 * 60 * 1000,
  refetchOnMount: true,
  refetchOnWindowFocus: true,
  refetchOnReconnect: true,
  gcTime: 30 * 60 * 1000,
})

export const followMeProfileStatsByIdQuery = (id: string) =>
  queryOptions({
    queryKey: [...queryKeys.followMeAccountProfileStats, id],
    queryFn: () => getPrincipleFollowMeUserProfileStats(id),
    staleTime: 10 * 60 * 1000,
    refetchOnWindowFocus: true,
    refetchOnMount: true,
    refetchOnReconnect: true,
    gcTime: 1_000 * 60 * 30, // 30min
  })

export const followMeProfileByIdQuery = (id: string) =>
  queryOptions({
    queryKey: [...queryKeys.followMeAccountProfileBase, id],
    queryFn: () => getFollowMeUserProfileById(id),
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    gcTime: 1_000 * 60 * 30, // 30min
    retry: (failureCount, error) => {
      if (isBetLoopProblemResponse(error) && error.isBanned) {
        return false
      }
      return failureCount < 3
    },
  })
